"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Contract = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Contract_ContentDefinition_1 = require("./RTTI_Contract_ContentDefinition");
var RTTI_Contract_Term_1 = require("./RTTI_Contract_Term");
var RTTI_Contract_Signer_1 = require("./RTTI_Contract_Signer");
var RTTI_Contract_Friendly_1 = require("./RTTI_Contract_Friendly");
var RTTI_Contract_Legal_1 = require("./RTTI_Contract_Legal");
var RTTI_Contract_Rule_1 = require("./RTTI_Contract_Rule");
var RTTI_Attachment_1 = require("./RTTI_Attachment");
exports.RTTI_Contract = t.recursion('IContract', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Contract')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            url: RTTI_uri_1.RTTI_uri,
            _url: RTTI_Element_1.RTTI_Element,
            version: t.string,
            _version: RTTI_Element_1.RTTI_Element,
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            legalState: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            instantiatesCanonical: RTTI_Reference_1.RTTI_Reference,
            instantiatesUri: RTTI_uri_1.RTTI_uri,
            _instantiatesUri: RTTI_Element_1.RTTI_Element,
            contentDerivative: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            issued: RTTI_dateTime_1.RTTI_dateTime,
            _issued: RTTI_Element_1.RTTI_Element,
            applies: RTTI_Period_1.RTTI_Period,
            expirationType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            subject: t.array(RTTI_Reference_1.RTTI_Reference),
            authority: t.array(RTTI_Reference_1.RTTI_Reference),
            domain: t.array(RTTI_Reference_1.RTTI_Reference),
            site: t.array(RTTI_Reference_1.RTTI_Reference),
            name: t.string,
            _name: RTTI_Element_1.RTTI_Element,
            title: t.string,
            _title: RTTI_Element_1.RTTI_Element,
            subtitle: t.string,
            _subtitle: RTTI_Element_1.RTTI_Element,
            alias: t.array(t.string),
            _alias: t.array(RTTI_Element_1.RTTI_Element),
            author: RTTI_Reference_1.RTTI_Reference,
            scope: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            topicCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            topicReference: RTTI_Reference_1.RTTI_Reference,
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            subType: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            contentDefinition: RTTI_Contract_ContentDefinition_1.RTTI_Contract_ContentDefinition,
            term: t.array(RTTI_Contract_Term_1.RTTI_Contract_Term),
            supportingInfo: t.array(RTTI_Reference_1.RTTI_Reference),
            relevantHistory: t.array(RTTI_Reference_1.RTTI_Reference),
            signer: t.array(RTTI_Contract_Signer_1.RTTI_Contract_Signer),
            friendly: t.array(RTTI_Contract_Friendly_1.RTTI_Contract_Friendly),
            legal: t.array(RTTI_Contract_Legal_1.RTTI_Contract_Legal),
            rule: t.array(RTTI_Contract_Rule_1.RTTI_Contract_Rule),
            legallyBindingAttachment: RTTI_Attachment_1.RTTI_Attachment,
            legallyBindingReference: RTTI_Reference_1.RTTI_Reference
        })
    ]);
});
//# sourceMappingURL=RTTI_Contract.js.map